import React, { useState } from 'react';
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Popover,
  TextField,
} from '@mui/material';
import PropTypes from 'prop-types';
import PopupTitle from '../common/popup_title';

const PublishConfirmationNotificationModal = ({
  titleText,
  promptText,
  notificationTitleTemplate,
  notificationTextTemplate,
  onPublish,
  onDismiss,
}) => {
  const [sendPushNotification, setSendPushNotification] = useState(false);
  const [notificationTitle, setNotificationTitle] = useState(
    notificationTitleTemplate || '',
  );
  const [notificationText, setNotificationText] = useState(
    notificationTextTemplate || '',
  );

  const isValidNotificationConfiguration =
    !sendPushNotification || (notificationTitle && notificationText);

  return (
    <Popover
      open
      PaperProps={{
        style: { width: '510px', height: '390px', padding: '10px' },
      }}
      onClose={onDismiss}
      onClick={(ev) => ev.stopPropagation()}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}>
      <Grid container style={{ fontSize: '14px' }}>
        <Grid item xs={12}>
          <PopupTitle
            titleText={titleText}
            closeButtonEnabled
            onClickClose={onDismiss}
          />
        </Grid>
        <Grid item xs={12} style={{ padding: '8px 20px 16px' }}>
          <Grid container>
            <Grid item xs={12} style={{ marginTop: '20px' }}>
              {promptText}
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={sendPushNotification}
                    onChange={(ev) => {
                      setSendPushNotification(ev.target.checked);
                    }}
                  />
                }
                label="Also send a push notification to your mobile app customers"
              />
            </Grid>
            <Grid item xs={12} style={{ margin: '0 20px 0 40px' }}>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{ color: sendPushNotification ? 'initial' : 'gray' }}>
                  Notification title (required)
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="standard"
                    fullWidth
                    value={notificationTitle}
                    disabled={!sendPushNotification}
                    inputProps={{
                      style: {
                        fontSize: '14px',
                      },
                    }}
                    onChange={(ev) => setNotificationTitle(ev.target.value)}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: '10px',
                    color: sendPushNotification ? 'initial' : 'gray',
                  }}>
                  Notification preview text (required)
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="standard"
                    value={notificationText}
                    disabled={!sendPushNotification}
                    multiline
                    fullWidth
                    rows={3}
                    inputProps={{
                      style: {
                        fontSize: '14px',
                      },
                    }}
                    onChange={(ev) => setNotificationText(ev.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} style={{ padding: '5px', marginTop: '20px' }}>
              <Button
                onClick={(ev) => {
                  onPublish(
                    sendPushNotification,
                    notificationTitle,
                    notificationText,
                  );
                  ev.stopPropagation();
                }}
                variant="contained"
                size="medium"
                color="primary"
                disableElevation
                disabled={!isValidNotificationConfiguration}
                style={{ justifyContent: 'flex-start' }}>
                Publish
              </Button>
              <Button
                onClick={(ev) => {
                  onDismiss();
                  ev.stopPropagation();
                }}
                variant="contained"
                size="medium"
                color="secondary"
                disableElevation
                style={{ justifyContent: 'flex-start' }}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Popover>
  );
};

PublishConfirmationNotificationModal.propTypes = {
  titleText: PropTypes.string.isRequired,
  promptText: PropTypes.string.isRequired,
  notificationTitleTemplate: PropTypes.string.isRequired,
  notificationTextTemplate: PropTypes.string.isRequired,
  onPublish: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default PublishConfirmationNotificationModal;
